import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAdmin } from '../../contexts/AdminContext';
import AdminLayout from '../../components/admin/AdminLayout';
import ImageUpload from '../../components/admin/ImageUpload';
import { Save } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminFounder = () => {
  const { getAuthHeaders } = useAdmin();
  const [formData, setFormData] = useState({
    name: '',
    bio: '',
    image: '',
    linkedin: '',
    twitter: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchFounder();
  }, []);

  const fetchFounder = async () => {
    try {
      const response = await axios.get(`${API}/admin/founder`, getAuthHeaders());
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching founder:', error);
    }
    setLoading(false);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/founder`, formData, getAuthHeaders());
      alert('Founder information updated successfully!');
    } catch (error) {
      console.error('Error saving founder:', error);
      alert('Error saving changes');
    }
    setSaving(false);
  };

  if (loading) return <AdminLayout><p className="text-white">Loading...</p></AdminLayout>;

  return (
    <AdminLayout>
      <div className="space-y-6">
        <h1 className="display-medium text-white">Founder & Team</h1>

        <div className="bg-white/10 border border-white/25 p-6 rounded-lg">
          <div className="space-y-4">
            <div>
              <label className="body-small text-white mb-1 block">Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full bg-white/10 border border-white/25 text-white px-4 py-2 rounded"
              />
            </div>

            <div>
              <label className="body-small text-white mb-1 block">Bio</label>
              <textarea
                value={formData.bio}
                onChange={(e) => setFormData({ ...formData, bio: e.target.value })}
                className="w-full bg-white/10 border border-white/25 text-white px-4 py-2 rounded h-32"
              />
            </div>

            <div>
              <ImageUpload
                label="Founder Image"
                value={formData.image}
                onChange={(v) => setFormData({ ...formData, image: v })}
                testId="founder-image"
              />
            </div>

            <div>
              <label className="body-small text-white mb-1 block">LinkedIn URL</label>
              <input
                type="text"
                value={formData.linkedin}
                onChange={(e) => setFormData({ ...formData, linkedin: e.target.value })}
                className="w-full bg-white/10 border border-white/25 text-white px-4 py-2 rounded"
              />
            </div>

            <div>
              <label className="body-small text-white mb-1 block">Instagram URL</label>
              <input
                type="text"
                value={formData.twitter}
                onChange={(e) => setFormData({ ...formData, twitter: e.target.value })}
                className="w-full bg-white/10 border border-white/25 text-white px-4 py-2 rounded"
              />
            </div>

            <button onClick={handleSave} disabled={saving} className="btn-primary flex items-center gap-2">
              <Save size={20} /> {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminFounder;
